import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { datadogRum } from '@datadog/browser-rum';
import { GlobalStateService } from '@app/shared/states';
import { TokenService } from '@app/shared/services/token.service';

@Injectable({
  providedIn: 'root',
})
export class DatadogMonitoringService {
  constructor(private globalState: GlobalStateService, private tokenService: TokenService) {}

  /** Function for Real User Monitoring with Datadog */
  setDataDogRum() {
    if (environment.dataDog) {
      datadogRum.init({
        applicationId: environment.dataDog.applicationId,
        clientToken: environment.dataDog.clientToken,
        site: environment.dataDog.site,
        service: environment.dataDog.service,
        env: environment.environment_name,
        version: environment.dataDog.version,
        sessionSampleRate: environment.dataDog.sessionSampleRate,
        sessionReplaySampleRate: environment.dataDog.sessionReplaySampleRate,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: 'mask-user-input',
      });

      let tokenDetails: any = this.tokenService.getDecodedToken();
      if (tokenDetails?.email) {
        datadogRum.setUser({
          id: tokenDetails.sub ? tokenDetails.sub : null,
          email: tokenDetails.email ? tokenDetails.email : 'Anonymous User',
          plan: 'premium',
        });
        datadogRum.startSessionReplayRecording();
        this.globalState.setDatadogState(true);
      }
    }
  }
}
